var map = {
	"./calls-taken-en.png": "VF/d",
	"./calls-taken-fr.png": "EV8Z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vGs1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice ^\.\/calls\-taken\-.*\.png$
// module id = vGs1
// module chunks = 0